import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account" }
const _hoisted_2 = { class: "main flex ps-52" }
const _hoisted_3 = { class: "main-sidebar h-full absolute h-full start-0 bg-sidebarBg z-20" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fixed w-52 z-10 bg-sidebarBg inset-0" }, null, -1)
const _hoisted_5 = { class: "relative main-container h-screen overflow-y-scroll content w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Sidebar, {
          navItems: _ctx.navItems,
          companyTitle: "TASLEEM"
        }, null, 8, ["navItems"])
      ]),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_router_view)
      ])
    ])
  ]))
}